import BlueToggle from "../../../../../common/BlueToggle";
import { useState } from "react";
import "./moderatorCardDisplay.css";
import LoadingDisplay from "../../../../../common/LoadingDisplay/LoadingDisplay";
import { useTranslation } from "react-i18next";

const ModeratorCardDisplay = ({
    moderatorObject,
    updateModerator,
    deleteModerator,
    manualApprovalState,
    replaceModerator,
}) => {
    const { t } = useTranslation("moderatorPage");

    const [approveDenyPermissionStatus, setApproveDenyPremissionStatus] =
        useState(moderatorObject.approveDenyPermission);
    const [isLoadinApprovalState, setIsLoadingApprovalState] = useState(false);

    const onClickXButton = () => deleteModerator(moderatorObject);

    const onToggleApprovalState = async () => {
        if (!isLoadinApprovalState) {
            setIsLoadingApprovalState(true);

            // temporarily set the value that it should be for smooth user expericence
            setApproveDenyPremissionStatus(
                (approveDenyPermissionStatus) => !approveDenyPermissionStatus,
            );
            replaceModerator({ ...moderatorObject, isLoading: true });
            const moderator = await updateModerator(
                moderatorObject,
                !approveDenyPermissionStatus,
            );

            // set the actuall value once it completed loading
            replaceModerator({ ...moderatorObject, isLoading: false });
            setApproveDenyPremissionStatus(moderator.approveDenyPermission);
            setIsLoadingApprovalState(false);
        }
    };

    const moderatorImageUrl = moderatorObject.modImageURL
        ? moderatorObject.modImageURL
        : "/imageNotFound.jpg";
    const moderatorUsername = moderatorObject.modUsername
        ? moderatorObject.modUsername
        : "Unkown";
    const manualApprovalStateClass = manualApprovalState
        ? "moderatorCardDisplayContainerApproveDeny"
        : "moderatorCardDisplayContainerApproveDenyDisabled";

    let display = (
        <>
            <div className="moderatorCardDisplayXButtonContainer">
                <button
                    className="moderatorCardDisplayXButton"
                    onClick={onClickXButton}
                    name="moderatorCardDisplayXButton"
                >
                    X
                </button>
            </div>
            <div className="moderatorCardDisplayImageNameContainer">
                <img
                    src={moderatorImageUrl}
                    className="moderatorCardDisplayImage"
                    alt={moderatorImageUrl}
                />
                <p className="moderatorCardDisplayName">{moderatorUsername}</p>
            </div>

            <hr className="moderatorCardDisplayHr"></hr>
            <div className="moderatorCardDisplayPremissionsContainer">
                <h2>{t("moderatorPremissionsTitle")}</h2>
                <div className={manualApprovalStateClass}>
                    <BlueToggle
                        title={t("approveAndDenyMemesTextToggle")}
                        onToggle={onToggleApprovalState}
                        state={approveDenyPermissionStatus}
                    />
                </div>
            </div>
        </>
    );

    if (moderatorObject.isLoading)
        display = (
            <div className="LoadingDisplayModeratorCardDisplay">
                <LoadingDisplay invert={true} globalDivOff={true} />
            </div>
        );
    return (
        <>
            <div className="moderatorCardDisplayContainer">{display}</div>
        </>
    );
};

export default ModeratorCardDisplay;
